import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "attachments", "fileItem", "attachmentTemplate" ]

  connect () {
    this.findUploadedFileNames()
  }

  addAnotherAttachment (event) {
    event.preventDefault()
    this.attachmentsTarget.appendChild(this.newAttachmentInput)
  }

  removeAttachment (event) {
    event.preventDefault()
    event.target.getParent().destroy()
  }

  change (event) {
    event.target.getParent('.file-item').querySelector('.file-attachment-name').textContent = event.target.value.split(/(\\|\/)/g).pop()
  }

  findUploadedFileNames () {
    Array.from(this.fileItemTargets).forEach(function(element) {
      if(element.querySelector('.cache-file-name')) {
        element.querySelector('.file-attachment-name').textContent = element.querySelector('.cache-file-name').value.split(/(\\|\/)/g).pop()
      }
    })
  }

  get newAttachmentInput () {
    let html = this.attachmentTemplateTarget.innerHTML
    html = html.replace(/0/g, this.newAttachmentId)
    return Elements.from(html)[0]
  }

  get newAttachmentId () {
    return this.attachmentsTarget.getChildren('div').length
  }
}